import { render, staticRenderFns } from "./ChartTrader.vue?vue&type=template&id=0f4d6e1d&"
import script from "./ChartTrader.vue?vue&type=script&lang=js&"
export * from "./ChartTrader.vue?vue&type=script&lang=js&"
import style0 from "./ChartTrader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports